/**
 * Sezione Profilo - Dati utente base
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { User } from 'lucide-react';

const ProfileSection = ({ user, t }) => {
  return (
    <Card data-testid="profile-section">
      <CardHeader>
        <CardTitle className="font-heading flex items-center gap-2">
          <User className="h-5 w-5" />
          {t('settings.profile')}
        </CardTitle>
        <CardDescription>
          {t('settings.profileDescription')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>{t('auth.email')}</Label>
            <Input value={user?.email || ''} disabled />
          </div>
          <div>
            <Label>{t('auth.role')}</Label>
            <Input value={user?.role === 'buyer' ? 'Acquirente' : user?.role === 'seller' ? 'Venditore' : user?.role || ''} disabled />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileSection;
